export default "__VITE_ASSET__BTXWFkzE__"